export default "__VITE_ASSET__CnxayRBj__"